/**
 * Faz 9 hata metinleri (yapay zekâ, İçerik Stüdyosu, SEO önerileri, YouTube…). Vitrin girişi de hata metinlerini
 * gördüğü için `shared.en.ts` → `errorsEn` içine yayılır (Faz 8 düzeniyle aynı; panel metinleri `ai.en.ts`'de).
 */
export const aiErrorsEn = {
  youtube_not_configured:
    'YouTube is not connected or not tested. Enter and test the API key on the Integrations screen.',
  youtube_key_format:
    'The API key format is wrong (Google Cloud → Credentials → API key; starts with "AIza", 39 characters).',
  youtube_key_invalid: 'Google did not accept this API key.',
  youtube_key_restricted:
    'The key is restricted: a browser (HTTP referrer) or app restriction blocks server use. Use an IP restriction and limit it to the YouTube Data API.',
  youtube_api_disabled:
    'YouTube Data API v3 is not enabled in the Google Cloud project. Enable it in the API Library.',
  youtube_quota: 'The YouTube daily quota is used up; try again tomorrow.',
  youtube_unreachable: 'YouTube could not be reached or its response could not be read. Try again later.',
  merchant_title_claims: 'The Google title cannot contain disease prevention/treatment claims.',
  merchant_title_too_long: 'The Google title can be at most 150 characters.',
  copilot_days: 'The period must be 7, 30 or 90 days.',
  copilot_question_required: 'Write your question in at least 3 characters.',
  ai_translation_source_invalid: 'The source post is not in this post’s translation group.',
  ai_translation_too_long: 'The post is too long to translate at once (max 40,000 characters).',
  ai_email_goal_required: 'Describe the campaign goal in at least 10 characters.',
  ai_support_drafts_disabled:
    'Support reply drafts are off. The owner can turn them on in AI settings (the customer message is sent masked).',
  studio_image_alt_required: 'Every image added to the draft needs alt text: ![alt text](zt-file:…).',
  ai_image_prompt_invalid: 'The image description must be 10 to 1000 characters.',
  ai_image_invalid:
    'The image returned by the provider could not be read; if it was charged it appears in the usage report. Try again.',
  ai_provenance_locked: 'The source of an AI-generated image cannot be changed.',
  file_not_image: 'The file is not an image.',
  studio_image_limit: 'At most 20 content images can be added.',
  studio_topic_required: 'The topic must be at least 3 characters.',
  studio_country_invalid: 'Country must be a two-letter code (e.g. TR).',
  studio_source_url_invalid: 'The source must be a valid http:// or https:// URL.',
  studio_too_many_sources: 'At most 20 sources can be added.',
  studio_draft_too_long: 'The draft can be at most 100,000 characters.',
  studio_path_invalid: 'An internal link must be a site path starting with "/".',
  studio_archived: 'The project is archived and cannot be changed.',
  studio_draft_empty: 'Write a draft before exporting.',
  studio_draft_invalid:
    'The draft could not be converted to the blog format (too long or too many elements).',
  studio_no_sources: 'No sources to verify. Add sources and save first.',
  studio_overwrite_confirm: 'This field has content; confirm to overwrite it.',
  studio_headings_required: 'Write the headings or generate a plan with AI before the draft.',
  ai_output_invalid: 'The AI response was not in the expected format; nothing was changed. Try again.',
  ai_not_configured:
    'No AI provider is connected (setup required). Enter the key on the Integrations screen and test the connection.',
  ai_not_enabled: 'AI is off. The business owner must set a monthly limit and approve it in AI settings.',
  ai_budget_exceeded:
    'Monthly AI spending limit reached (limit {{limit}} USD, spent {{spent}} USD). You can raise it in AI settings.',
  ai_daily_limit: 'Daily AI request limit ({{limit}}) reached. Try again tomorrow.',
  ai_invalid_key: 'The provider rejected the API key. Renew it on the Integrations screen.',
  ai_invalid_settings: 'The API key is empty or malformed.',
  ai_provider_rate_limited: 'The provider rate limit was hit. Try again in a few minutes.',
  ai_provider_overloaded: 'The provider is busy right now. Try again shortly.',
  ai_provider_rejected: 'The provider rejected the request (the model name or a setting may be wrong).',
  ai_provider_timeout:
    'The provider did not respond in time. The reserved amount was counted because the request may have been processed.',
  ai_provider_unreachable: 'Could not reach the provider. Try again shortly.',
  ai_provider_bad_response: "The provider's response could not be read.",
  ai_output_empty: 'The AI returned an empty response. Change the input and try again.',
  ai_refused: 'The AI declined this request. Change the input and try again.',
  ai_model_price_missing: 'The price of model "{{model}}" is unknown. Add it to the price table first.',
  ai_model_invalid: 'Invalid model name (lowercase letters, digits, dots and hyphens).',
  ai_ack_required: 'You must confirm that you are turning on a paid service.',
  month_invalid: 'Month must be in YYYY-MM format.',
  forecast_history: 'History must be between 8 and 104 weeks.',
  forecast_days: 'Days must be between 0 and 365.',
  forecast_review: 'The review period must be between 1 and 180 days.',
  forecast_overstock: 'The overstock threshold must be between 30 and 730 days.',
  ai_limit_invalid: 'The monthly limit must be between 1 and 10,000 USD.',
  ai_daily_limit_invalid: 'The daily request limit must be between 1 and 5000.',
  ai_image_reserve_invalid: 'The upper bound per image must be between 0.001 and 5 USD.',
  recommendation_window: 'The period must be between 30 and 730 days.',
  recommendation_min_buyers: 'Minimum distinct buyers must be between 2 and 50 (at least 2 for privacy).',
  recommendation_confidence: 'Confidence must be between 0 and 100 percent.',
  recommendation_max: 'Recommendations per product must be between 1 and 20.',
};
